<template>
  <div class="pb-3" >
    <va-card :title="$t(`rooms.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Nome" v-slot="{ errors }">
                <va-input
                  v-model="room.name"
                  :label="$t('rooms.forms.nameLabel')"
                  :placeholder="$t('rooms.forms.namePlaceholder')"
                  :success="errors.length == 0 && room.name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <va-toggle
                v-model="room.paid"
                small
                :label="$t('rooms.forms.paidPlaceholder')"
              />
              <va-toggle
                v-model="room.active"
                small
                :label="$t('rooms.forms.activePlaceholder')"
              />
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'RoomsAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      room: {
        name: '',
        paid: false,
        active: true,
      },
      logo: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  created () {
    this.room.name = ''
    this.room.paid = false
    if (this.updateData !== null) {
      this.room_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.room_get(this.updateData)
      } else {
        this.room.name = ''
        this.room.paid = false
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    room_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          this.room[value] = data[value]
        }
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { name, paid, active } = this.room
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation MyMutation($name: String!, $paid: Boolean, $active: Boolean, $id: Int!) {
                  update_room_by_pk(pk_columns: {id: $id}, _set: {name: $name, paid: $paid, active: $active}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($name: String, $paid: Boolean, $active: Boolean) {
                  insert_room(objects: {name: $name, paid: $paid, active: $active}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            name,
            paid,
            active,
            id: this.room.id,
          } : {
            name,
            paid,
            active,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.room.name = ''
          self.room.logo = ''
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.room.name = ''
          self.room.logo = ''
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
